import { createAction, props } from '@ngrx/store';
import { CostGenericDoc } from '../_models/financials';

// Action types
export const loadCostGenericDocs = createAction('[CostGenericDoc] Load CostGenericDocs');
export const loadCostGenericDocsSuccess = createAction(
  '[CostGenericDoc] Load CostGenericDocs Success',
  props<{ costGenericDocs: CostGenericDoc[] }>()
);
export const loadCostGenericDocsFailure = createAction(
  '[CostGenericDoc] Load CostGenericDocs Failure',
  props<{ error: any }>()
);

export const addCostGenericDoc = createAction(
  '[CostGenericDoc] Add CostGenericDoc',
  props<{ costGenericDoc: CostGenericDoc }>()
);
export const addCostGenericDocSuccess = createAction(
  '[CostGenericDoc] Add CostGenericDoc Success',
  props<{ costGenericDoc: CostGenericDoc }>()
);
export const addCostGenericDocFailure = createAction(
  '[CostGenericDoc] Add CostGenericDoc Failure',
  props<{ error: any }>()
);

export const updateCostGenericDoc = createAction(
  '[CostGenericDoc] Update CostGenericDoc',
  props<{ costGenericDoc: CostGenericDoc }>()
);
export const updateCostGenericDocSuccess = createAction(
  '[CostGenericDoc] Update CostGenericDoc Success',
  props<{ costGenericDoc: CostGenericDoc }>()
);
export const updateCostGenericDocFailure = createAction(
  '[CostGenericDoc] Update CostGenericDoc Failure',
  props<{ error: any }>()
);

export const deleteCostGenericDoc = createAction(
  '[CostGenericDoc] Delete CostGenericDoc',
  props<{ id: number }>()
);
export const deleteCostGenericDocSuccess = createAction(
  '[CostGenericDoc] Delete CostGenericDoc Success',
  props<{ id: number }>()
);
export const deleteCostGenericDocFailure = createAction(
  '[CostGenericDoc] Delete CostGenericDoc Failure',
  props<{ error: any }>()
);
